export default function getFlagBaseUrl() {
  const staticUrl = window.idem?.STATIC_URL
    || import.meta.env.VITE_APP_WEBSITE_STATIC_URL
    || '/static/';
  return `${staticUrl.replace(/\/?$/, '/')}flag-icon-css/flags/4x3/`;
}
